"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactEmotion = _interopRequireWildcard(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Section = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e1w0lkbf0"
})(_base.default, ";", _font.default, ";font-family:", function (props) {
  return props.font ? props.font : "'Inter', sans-serif";
}, ";width:100%;padding:80px 0;background-color:#062033;text-align:center;p{font-size:18px;}");
var Layout = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e1w0lkbf1"
})("width:100%;max-width:1200px;padding:0 15px;margin:0 auto;display:flex;flex-direction:row;justify-content:space-between;@media all and (max-width:640px){flex-direction:column;justify-content:flex-start;img{max-width:200px;margin-bottom:40px;}}");
var left = /*#__PURE__*/
(0, _reactEmotion.css)("width:240px;padding:20px;@media all and (max-width:640px){width:100%;}");
var right = /*#__PURE__*/
(0, _reactEmotion.css)("width:calc(100% - 300px);padding:20px;display:flex;flex-direction:row;justify-content:space-between;flex-wrap:wrap;@media all and (max-width:640px){width:100%;flex-direction:column;justify-content:flex-start;flex-wrap:nowrap;}");
var list = /*#__PURE__*/
(0, _reactEmotion.css)("padding:0 20px;margin:0;list-style:none;text-align:left;display:flex;flex:1;flex-direction:column;h4{margin-top:0;color:#5f678a;text-transform:uppercase;font-size:0.85rem;letter-spacing:0.05rem;font-weight:600;}a{color:#899fc6;line-height:2.2rem;letter-spacing:0.01rem;font-size:14px;border-bottom:1px solid transparent;text-decoration:none;&:hover{color:#eee;border-bottom:1px solid #eee;}}@media all and (max-width:768px){margin-bottom:50px;h4{font-size:0.95rem;}a{font-size:16px;line-height:38px;}}@media all and (max-width:640px){text-align:center;}");
var Footer = /*#__PURE__*/
function (_Component) {
  function Footer() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Footer.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      style = _this$props.style,
      children = _this$props.children;
    return _react.default.createElement(Section, {
      className: className,
      style: style
    }, _react.default.createElement(Layout, null, children));
  };
  _inheritsLoose(Footer, _Component);
  return Footer;
}(_react.Component);
exports.default = Footer;
_defineProperty(Footer, "Brand", function (_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return _react.default.createElement("div", {
    style: style,
    className: (0, _reactEmotion.cx)(left, className)
  }, children);
});
_defineProperty(Footer, "Links", function (_ref2) {
  var children = _ref2.children,
    className = _ref2.className,
    style = _ref2.style;
  return _react.default.createElement("div", {
    style: style,
    className: (0, _reactEmotion.cx)(right, className)
  }, children);
});
_defineProperty(Footer, "List", function (_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    style = _ref3.style;
  return _react.default.createElement("ul", {
    style: style,
    className: (0, _reactEmotion.cx)(list, className)
  }, children);
});
Footer.propTypes = {
  children: _propTypes.any,
  className: _propTypes.string,
  style: _propTypes.object
};